// TabManager utility functions
import { ACTIVE_TAB_LIMIT } from '@/constants/settings';

export function getCurrentTabId() {
  return sessionStorage.getItem('tabId');
}

export function isCurrentTabActive() {
  const tabId = getCurrentTabId();
  const activeTabs = getActiveTabs();
  return activeTabs.includes(tabId);
}

export function updateActiveTabs(onAdd = true) {
  const tabId = getCurrentTabId();
  let tabs = getActiveTabs();

  if (onAdd) {
    if (!tabs.includes(tabId)) {
      tabs.push(tabId);
    }
    if (ACTIVE_TAB_LIMIT > 0 && tabs.length > ACTIVE_TAB_LIMIT) {
      tabs = tabs.slice(-ACTIVE_TAB_LIMIT);
    }
  } else {
    tabs = tabs.filter(id => id !== tabId);
  }

  localStorage.setItem('activeTabs', JSON.stringify(tabs));

  return tabs;
}

export function removeCurrentTab() {
  return updateActiveTabs(false);
}

export function cleanupTabManager() {
  window.removeEventListener('beforeunload', handleTabClose);
}

export function initTabManager() {
  if (!sessionStorage.getItem('tabId')) {
    sessionStorage.setItem('tabId', crypto.randomUUID());
  }

  setupEventListeners();
}

function getActiveTabs() {
  const raw = localStorage.getItem('activeTabs');
  return raw ? JSON.parse(raw) : [];
}


function handleTabClose() {
  removeCurrentTab();
}

function setupEventListeners() {
  window.addEventListener('beforeunload', handleTabClose);
}